module.exports = __webpack_public_path__ + "static/img/Nick-Kay.93a2bb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nick-Kay.jpg
// module id = ur8D
// module chunks = 1